import { Box, Theme } from "@mui/material";

import { LegendItem as LegendItemComponent } from "@/Components/v2/molecule/LegendItem/LegendItem";

export type LegendItem = {
  id: string;
  color: string;
  title: string;
  isActive: boolean;
  onChange: () => void;
};

type LegendProps = {
  theme: Theme;
  legends: LegendItem[];
};

const Legend = ({ theme, legends }: LegendProps) => (
  <>
    {legends.map((legend) => (
      <Box
        key={legend.id}
        border={`1px solid ${theme.palette.divider}`}
        borderRadius={20}
        py={0.5}
        px={1}
      >
        <LegendItemComponent
          item={{
            id: legend.id,
            color: legend.color,
            title: legend.title,
            isActive: legend.isActive,
          }}
          handleClick={legend.onChange}
        />
      </Box>
    ))}
  </>
);

export default Legend;
